export function BarcodePattern({ className = "" }: { className?: string }) {
  const heights = [4, 2, 6, 3, 5, 2, 4, 3, 6, 2, 5, 4, 2, 3];

  return (
    <div className={`flex gap-[2px] ${className}`}>
      {heights.map((height, i) => (
        <div
          key={`bar-${String(height)}-${String(i)}`}
          className="bg-current opacity-20"
          style={{ width: "2px", height: `${String(height * 4)}px` }}
        />
      ))}
    </div>
  );
}
